//import moment = require("moment");
import * as moment from 'moment';

export class Notification {
    public id?: number;
    public title: string;
    public message: string;
    public created_at?: string;
    public data?: any;

    public set $id(v: number) { this.id = v; }
    public set $title(v: string) { this.title = v; }
    public set $message(v: string) { this.message = v; }
    public set $created_at(v: string) { this.created_at = v; }
    public set $data(v: any) { this.data = v; }

    public get _id() { return this.id; }
    public get _title() { return this.title; }
    public get _message() { return this.message; }
    public get _created_at() { return this.created_at; }
    public get _data() { return this.data; }

    constructor(data?: NotificationInterface) {
        this.created_at = moment().format()
        if(data) {
            this.crateWithValues(data)
        }
    }

    crateWithValues(element: NotificationInterface): any {
        this.id = this.loadData(element.id)
        this.title = this.loadData(element.title)
        this.message = this.loadData(element.message)
        // this.created_at = this.loadData(element.created_at)
        if(element.data) {
            this.data = JSON.parse(element.data)
        }
    }

    private loadData<T>(data: T, defaul?: T) {
        return data === undefined ?
            defaul !== undefined ? defaul : null : data
    }
}

export interface NotificationInterface {
    id?: number;
    title: string;
    message: string;
    created_at?: string;
    data?: any;
}



// WEBPACK FOOTER //
// ./src/app/models/notification.model.ts